import React from "react";
import infoIcon from "@/assets/svgs/info.svg";
import Image from "next/image";
import "./FindFin.css";

function FindFin({ setIsFindFinPopupOpen, addMargin, autoverkaufen = false }) {
  return (
    <div
      className={`findfin ${autoverkaufen ? "autoverkaufen" : ""}`}
      style={{
        marginTop: addMargin ? "12px" : "",
      }}
    >
      <div className="findfin-wrapper">
        <Image
          src={infoIcon}
          alt="Wo finde ich meine fin?"
          className="findfin-icon"
        />

        <div className="vertical-line"></div>
        <div className="findfin-text-wrapper">
          <span className="find-fin-text">
            Nicht sicher, wo du die FIN findest?
          </span>
          <span
            onClick={() => setIsFindFinPopupOpen(true)}
            className="find-fin-text-secondary"
          >
            So findest du die FIN
          </span>
        </div>
      </div>
    </div>
  );
}

export default FindFin;
